import React, { useEffect, useState } from "react";
import "./style.css";
import Metrics from "./Metrics";
import { getMetrics } from "../../api/metrics";
import { DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const Dashboard = () => {
  const _startDate = dayjs().startOf("month");
  const _endDate = dayjs();
  const [dateRange, setDateRange] = useState([_startDate, _endDate]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    _getData();
  }, [dateRange]);

  const _getData = async () => {
    const _dates = {
      start: dayjs(dateRange[0]).startOf("day").valueOf(),
      end: dayjs(dateRange[1]).endOf("day").valueOf(),
    };
    setLoading(true);
    await getMetrics(_dates);
    setLoading(false);
  };

  return (
    <div className="dashboard_container">
      <div className="dashboard_header">
        <h1 className="pageHeading" style={{ margin: 0 }}>
          Dashboard
        </h1>
        <div>
          <RangePicker
            defaultValue={[_startDate, _endDate]}
            size="large"
            onChange={(dates) => setDateRange(dates)}
            allowClear={false}
          />
        </div>
      </div>
      <Metrics loading={loading} />
    </div>
  );
};

export default Dashboard;
